import { render } from "./NavigationPanelPropsCmp.vue?vue&type=template&id=85dc1af0"
import script from "./NavigationPanelPropsCmp.vue?vue&type=script&lang=js"
export * from "./NavigationPanelPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__